<div class="HS DialerTable zoomIn long-header">
  <form [formGroup]="configForm" autocomplete="off" class="box weightageTable">
    <ng-container formArrayName="configRows">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 mat-table-custom">

        <!-- Env -->
        <ng-container matColumnDef="env">
          <th mat-header-cell *matHeaderCellDef style="width:16%"> Environment </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
            <mat-form-field floatLabel="auto">
              <input matInput formControlName="Environment" readonly>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- TenantId -->
        <ng-container matColumnDef="tenantId">
          <th mat-header-cell *matHeaderCellDef> Tenant </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
            <mat-form-field floatLabel="auto">
              <input matInput formControlName="TenantId" readonly>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Env Mode (env-level reference) -->
        <ng-container matColumnDef="envMode">
          <th mat-header-cell *matHeaderCellDef style="width:16%"> Environment Mode </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
            <strong>{{ getModeLabel(getEnvEffectiveMode(getFormValue(i).Environment)) }}</strong>
          </td>
        </ng-container>

        <!-- Mode -->
        <ng-container matColumnDef="mode">
          <th mat-header-cell *matHeaderCellDef> {{ selectedLevel?.tenantId ? 'Country Mode' : 'Environment Mode' }} </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
            <ng-container *ngIf="!getFormValue(i).OnEdit">
              <span *ngIf="getFormValue(i).Mode === 'Disabled'" style="color: red;">🚫</span>
              <span *ngIf="getFormValue(i).Mode === 'Inherited'">🔗</span>
              <span *ngIf="getFormValue(i).Mode !== 'Disabled' && getFormValue(i).Mode !== 'Inherited'" style="color: green;">✔️</span>
              <strong>{{ getModeLabel(getFormValue(i).Mode) }}</strong>
            </ng-container>
            <mat-form-field floatLabel="auto" *ngIf="getFormValue(i).OnEdit">
              <mat-select formControlName="Mode">
                <mat-option *ngFor="let v of availableModes" [value]="v">
                  <strong>{{ getModeLabel(v) }}</strong>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
            <button mat-icon-button color="primary" *ngIf="!getFormValue(i).OnEdit"
                    (click)="onRowEditInit(i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" *ngIf="getFormValue(i).OnEdit"
                    (click)="onRowEditCancel(i)">
              <mat-icon>rotate_left</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Footer -->
        <ng-container matColumnDef="savefooter">
          <th mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplay.length">
            <div class="OrangeButton">
              <button mat-raised-button type="submit"
                      (click)="onSave()"
                      [disabled]="!anyChange()"
                      class="button-color-fix pull-right">
                Save
                <mat-icon style="color:white">save</mat-icon>
              </button>
            </div>
          </th>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
        <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true"></tr>

      </table>
    </ng-container>
  </form>
</div>